import { MetadataItem } from '@gelato-api-ui/core/metadata/types/metadata-item';
import { getMetadataItemValue } from '@gelato-api-ui/core/metadata/helpers/getMetadataItemValue';

export const getProductVariantIdFromMetadata = (metadata: MetadataItem[]): string =>
  getMetadataItemValue(metadata, 'productVariantId', true) as string;
